import TableCell from './table-cell';

export default TableCell;